import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortDesc = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 12,
	viewBox: "0 0 8 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.38181 7H3.82199H0.616411C0.0678665 7 -0.206406 7.75891 0.182146 8.2038L3.14202 11.5927C3.61628 12.1358 4.38767 12.1358 4.86194 11.5927L5.98759 10.3039L7.82179 8.2038C8.20463 7.75891 7.93036 7 7.38181 7Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		opacity: .5,
		d: "M0.618193 5.00081L4.17802 5.00513L7.38359 5.00902C7.93213 5.00968 8.20733 4.2511 7.81931 3.80575L4.86356 0.413217C4.38995 -0.130373 3.61856 -0.131309 3.14364 0.41113L2.01642 1.69861L0.179675 3.79647C-0.203703 4.2409 0.0696482 5.00014 0.618193 5.00081Z",
		fill: "currentColor"
	})]
});
export default SvgSortDesc;
